// extracted by mini-css-extract-plugin
module.exports = {"root":"_1q3Hf","content":"_1VNXM","withShadow":"_1Kc_O"};